import React, { FunctionComponent, useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ShoppingPlannerContext } from '../../Context/ShoppingPlannerContext';
import { accessoriesPrefix, urls } from '../../Constants/Urls';
import { Button } from '../Button/Button';
import { useResponsive } from '../../Hook/UseResponsive';

import './Header.scss';

export const Header: FunctionComponent = () => {
    const location = useLocation();
    const { locked, slug } = useContext(ShoppingPlannerContext);

    const { isLargerThanMd } = useResponsive();

    return (
        <header className="shopping-planner-header">
            <img
                className="shopping-planner-header__logo"
                src="/_Resources/Static/Packages/GesagtGetan.Theme/Assets/Logo.svg"
            />
            <nav
                className={[
                    'shopping-planner-header__navigation',
                    locked ? 'shopping-planner-header__navigation--locked' : '',
                ].join(' ')}
            >
                <ul className="shopping-planner-header__navigation-list">
                    <li>
                        <NavLink
                            className={({ isActive, isPending }) =>
                                [
                                    'shopping-planner-header__link',
                                    isActive ? 'shopping-planner-header__link--active' : '',
                                ].join(' ')
                            }
                            to={urls.steps.room.builder()}
                        >
                            <span className="shopping-planner-header__link-label">Raum</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={({ isActive, isPending }) =>
                                [
                                    'shopping-planner-header__link',
                                    isActive ? 'shopping-planner-header__link--active' : '',
                                ].join(' ')
                            }
                            to={urls.steps.floor.builder()}
                        >
                            <span className="shopping-planner-header__link-label">Boden</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={({ isActive, isPending }) =>
                                [
                                    'shopping-planner-header__link',
                                    isActive || location.pathname.startsWith(accessoriesPrefix)
                                        ? 'shopping-planner-header__link--active'
                                        : '',
                                ].join(' ')
                            }
                            to={urls.steps.accessoriesInsulation.builder()}
                        >
                            <span className="shopping-planner-header__link-label">Zubehör</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={({ isActive, isPending }) =>
                                [
                                    'shopping-planner-header__link',
                                    isActive ? 'shopping-planner-header__link--active' : '',
                                ].join(' ')
                            }
                            to={urls.steps.shoppingList.builder(slug)}
                        >
                            <span className="shopping-planner-header__link-label">Einkaufszettel</span>
                        </NavLink>
                    </li>
                </ul>
            </nav>
            <Button onClick={() => (window.location.href = '/')} mirror={true} icon="arrow">
                {isLargerThanMd ? 'Zurück zur Website' : 'zurück'}
            </Button>
        </header>
    );
};
